const voting = {
  tableTitle: "Ballots",
  tableDescription:
    "For any issue that needs to have a vote tabulated, a separate Ballot should be created. Separate Ballots are required for each Class or Meeting.",
  createNewBallot: "New Ballot",
  createBallotTitle: "Create a new Ballot",
  viewVersion: "View Version",
  newMeeting: "New Meeting",
  statusConfirmMessageHeading: "Are you sure to lock this ballot?",
  statusConfirmMessageDescription:
    "Locked ballot will no longer be editable after saving.",
  creditorVotes: {
    confirmationMessage:
      "Are you sure you want to delete this vote <strong>{{voterName}}</strong>?",
    successMessage: "Vote deleted successfully.",
    manualRecording: {
      title: "Record creditor votes",
      creditorSearch: "Search for a Creditor",
      vote: "Vote",
      yes: "Yes",
      no: "No",
      didNotVote: "Did Not Vote",
      proxy: "Proxy",
      noCreditorsExist: "No creditor exist for the selected class.",
    },
    bulkVoting: {
      title: "Import Creditor Votes",
      description: "Download template to create the import file",
      uploadLabel: "Upload Import File",
      uploadDescription:
        "The accepted document format is XLSX only. The maximum size per file is 250 MB.",
    },
    moreOptions: {
      label1: "Manual Recording",
      label2: "Bulk Import",
    },
    createMeeting: {
      meetingName: "Meeting Name",
      meetingDate: "Meeting Date",
      meetingNameReq: "Meeting Name is required",
      meetingDateReq: "Meeting Date is required",
    },
    export: "Export",
    newVote: "New Vote",
    tableTitle: "Creditor Votes",
    tableDescription: "Below is a table of individual votes by creditor.",
    columnDetails: {
      column1: "Creditor Name",

      column2: "Creditor ID",

      column3: "Proxy Name",

      column4: "Vote Result",

      column5: "Eligible",
      column6: "Unresolved Creditor Position ({{unitName}})",
      column7: "Unresolved Debtor Position ({{unitName}})",
      column8: "Resolved Amount ({{unitName}})",
      column9: "Voter ID",
      column10: "Voter Name",
    },
  },
  bannerDetails: {
    ballotName: "Ballot Name",
    ballotStatus: "Ballot Status",
    class: "Class",
    meeting: "Meeting",
  },
  ballotResult: {
    tableTitle: "Ballot Result",
    tableDescription: "Below is a summary of the votes by count and value.",
    columnDetails: {
      column1: "Votes",

      column2: "Votes Count",

      column3: "Votes Count %",

      column4: "Resolved Amount ({{unitName}})",

      column5: "Resolved Amount %",

      column6: "Latest Creditor Amount ({{unitName}})",

      column7: "Latest Creditor Amount %",

      column8: "Latest Debtor Amount ({{unitName}})",

      column9: "Latest Debtor Amount %",
    },
  },
  validationMessages: {
    ballotNameRequired: "Ballot Name is required",
    ballotNameFrenchRequired: "Ballot French Name is required",
    schemeRequired: "Scheme is required",
    classRequired: "Class is required",
    meetingRequired: "Meeting is required",
    statusRequired: "Status is required",
  },
  formLabels: {
    nameEnglish: "Ballot Name (English)",
    nameFrench: "Ballot Name (French)",
    attributeDescriptionEnglish: "Ballot Description (English)",
    attributeDescriptionFrench: "Ballot Description (French)",
    scheme: "Scheme",
    allowedClass: "Allowed Class",
    export: "Export Eligible Voters",
    meeting: "Meeting",
    proxy: "Attendance By Proxy Required",
    ballotStatus: "Ballot Status",
    votedYes: "% Who Voted Yes",
    claimValue: "% Claim Value",
    conditionForSuccess: "Condition For Success",
  },
  ballotStatusOptions: {
    label1: "Select Type",
    label2: "Open",
    label3: "Locked",
  },
  tabPannelDetails: {
    summary: "Summary",
    creditorVotes: "Creditor Votes",
  },
  tableColumnsDetails: {
    column1: "Ballot Name",
    column2: "Class",
    column3: "Meeting",
    column4: "Ballot Status",
    column5: "% Voted Yes",
    column6: "% Claim Value",
    column7: "Attendance By Proxy Required",
  },
};

export default voting;
